var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "row mb-1" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("div", { staticClass: "ob1-skeleton" }, [
            _c("div", {
              staticClass: "ob1-skeleton-white mb-1",
              staticStyle: { height: "200px" },
            }),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }